/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function (React, Toolkit, PropTypes) {

	const { Dialog } = Toolkit;

	class MessageComponent extends React.Component {

		constructor(props = {}) {
			super(props);
			let className = 'dashboardMessageDialog';
			if(props.className) {
				className += ` ${props.className}`;
			} else {
				className += ' none';
			}
			this.dialogProps = {
				className: className,
				size: props.size || 'small',
				clickaway: false
			};
		}

		render() {
			return(
				<Dialog
					{...this.dialogProps}
					onClose={this._onClose.bind(this)}
				>
					<Dialog.Header title={this.props.title}>
						{this.props.title}
					</Dialog.Header>
					<Dialog.Body>
						{this.props.message}
					</Dialog.Body>
					<Dialog.Footer>
						<Dialog.Button
							primary
							id='ok'
							label={this.props.okLabel}
							onClick={this._onClose.bind(this)}
						/>
					</Dialog.Footer>
				</Dialog>
			);
		}

		_onClose(evt) {
			if (evt) {
				evt.stopPropagation();
			}

			if (this.props.onClose) {
				this.props.onClose();
			}
		}
	}

	MessageComponent.propTypes = {
		size: PropTypes.string,
		className: PropTypes.string,
		title: PropTypes.string,
		message: PropTypes.string,
		onClose: PropTypes.func,
		okLabel: PropTypes.string
	};
	return MessageComponent;
});
